import { Routes } from '@angular/router';
import { provideSavingPlansDomain } from '@zero/saving-plans/domain';
import { provideTradeDomain } from '@zero/trade/domain';

export const SAVINGS_PLAN_WEB_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/saving-plans-page/saving-plans-page.component').then((c) => c.SavingPlansPageComponent),
    providers: [provideSavingPlansDomain(), provideTradeDomain()],
  },
  {
    path: 'sparplan-einrichten',
    loadComponent: () =>
      import('./pages/savings-plan-create-page/savings-plan-create-page.component').then((c) => c.SavingsPlanCreatePageComponent),
    providers: [provideSavingPlansDomain(), provideTradeDomain()],
  },
  {
    path: 'sparplan-einrichten/:isin',
    loadComponent: () =>
      import('./pages/savings-plan-create-page/savings-plan-create-page.component').then((c) => c.SavingsPlanCreatePageComponent),
    providers: [provideSavingPlansDomain(), provideTradeDomain()],
  },
  {
    path: 'sparplan-editieren/:id',
    loadComponent: () =>
      import('./pages/savings-plan-edit-page/savings-plan-edit-page.component').then((c) => c.SavingsPlanEditPageComponent),
    providers: [provideSavingPlansDomain(), provideTradeDomain()],
  },
];
